import { Box, IconButton, MenuItem, TextField } from "@mui/material";
import { PropValueLine } from "../../common/PropValueLine";
import { WorldRenderer } from "../../WorldRenderer";
import { useEffect, useState } from "react";
import { ModelBasedVisual } from "../../../visuals/ModelBasedVisual";
import { FloorVisual } from "../../../visuals/FloorVisual";
import { Assignment, Refresh } from "@mui/icons-material";
import { cloneVec3 } from "../../../visuals/visual-utils";
import { WREvents } from "../../WREvents";
import { FlexContainer } from "../../../components/FlexContainer";

export function ModelBasedProps({ wr, modelBased, onUpdate }: {
  wr: WorldRenderer,
  modelBased: ModelBasedVisual,
  onUpdate: (visual: Partial<ModelBasedVisual>) => void
}) {
  const [floors, setFloors] = useState<FloorVisual[]>([]);
  const [cameraIndex, setCameraIndex] = useState<number>(-1);
  useEffect(() => {
    const fs = Array.from(wr.dataService.visuals.values()).filter(v => v instanceof FloorVisual) as FloorVisual[];
    setFloors(fs);
  }, [wr]);
  if (floors.length === 0) return null;
  return (
    <>
      <PropValueLine label='Camera' value={
        <FlexContainer>
          <TextField
            select
            value={cameraIndex}
            variant="standard"
            size="small"
            onChange={(e) => {
              const index = parseInt(e.target.value);
              setCameraIndex(index);
              if (index < 0) {
                modelBased.wr.emitEvent(WREvents.CameraSelected, null);
              } else {
                modelBased.wr.emitEvent(WREvents.CameraSelected, modelBased, index);
              }
            }}
          >
            <MenuItem value={-1}>
              <em>None</em>
            </MenuItem>
            {modelBased.getCameras().map((c, index) => (
              <MenuItem key={index} value={index}>
                {c.name}
              </MenuItem>
            ))}
          </TextField>
          <IconButton
            size='small'
            onClick={() => {
              modelBased.wr.emitEvent(WREvents.CameraSelected, null);
              modelBased.wr.emitEvent(WREvents.CameraSelected, modelBased, cameraIndex);
            }}
          >
            <Refresh />
          </IconButton>
        </FlexContainer>
      } />

      <PropValueLine label='Floor' value={
        <FlexContainer>
          <TextField
            select
            value={modelBased.floorId || ''}
            variant="standard"
            size="small"
            onChange={(e) => {
              onUpdate({ floorId: e.target.value });
            }}
          >
            <MenuItem value="">
              <em>None</em>
            </MenuItem>
            {floors.map((r) => (
              <MenuItem key={r._id} value={r._id}>
                {r.id}
              </MenuItem>
            ))}
          </TextField>
          <IconButton
            size='small'
            onClick={() => {
              if (modelBased.floorId) {
                const floor = wr.dataService.visuals.get(modelBased.floorId);
                if (floor) {
                  onUpdate({ position: cloneVec3(floor.position) });
                }
              }
            }}
          >
            <Assignment />
          </IconButton>
        </FlexContainer>
      } />
      <PropValueLine label='Model' value={modelBased.modelLoader.model.name} />
    </>
  );
} 